import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { LineBreak, NetworkLogo } from '~/views/components/tvBroadcast/styles';

export const HeaderWrapper = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
    
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        ${BaseStyle.Mixins.gaps.small}
    }
`;

export const DraftImage = styled.img`
    height: 32px;
`;

export const MediumGapContainer = styled.div<{ $expand?: boolean }>`
    ${BaseStyle.Mixins.gaps.medium}

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;

    ${LineBreak} {
        background: none;
    }

    ${NetworkLogo} {
        max-width: initial;
    }

    ${({ $expand }) =>
        $expand
            ? css`
                  flex: 1;
              `
            : ''}

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        ${BaseStyle.Mixins.gaps.extraSmall}

        flex-direction: column;
        align-items: start;
    }
`;

export const SemiMediumGapContainer = styled(MediumGapContainer)`
    ${BaseStyle.Mixins.gaps.semiMedium}
`;

export const DraftTime = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
`;

export const LiveIndicator = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}

    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.Utility.critical};
    text-transform: uppercase;

    svg {
        fill: ${({ theme }) => theme.Utility.critical};
        height: 8px;
        width: 8px;
    }
`;

export const FinalIndicator = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    color: ${({ theme }) => theme.Text.primary};
    background-color: ${({ theme }) => theme.Surface.border};
    padding: 4px 8px;
    border-radius: 4px;
`;
